import { useDispatch, useSelector } from "react-redux";
import ModalBody from "../../../../../../shared/components/Modals/ModalBody";
import ModalComponent from "../../../../../../shared/components/Modals/ModalComponent";
import { selectIsGenerateEvaluationKitOpen, setGenerateEvaluationKitModal } from "../../../../../interview/slice/interviewSlice";
import { GenerateNewKitForm } from "../../../../../interview/components/kit/GenerateNewKitForm";

function GenerateKitModal() {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectIsGenerateEvaluationKitOpen);
  const closeModal = () => {
    dispatch(setGenerateEvaluationKitModal(false))

  };
  
  return (
    <ModalComponent
      visibleModal={isOpen}
      handleCloseModal={closeModal}
      className="!w-[60rem]"
      content={
        <ModalBody
          title={<p className="border-b-2 pb-3.5">Evaluation Questions</p>}
          className="text-start"
        >
          <GenerateNewKitForm fromProfile={true} className="!h-[26.25rem]" />
        </ModalBody>
      }
    />
  );
}

export default GenerateKitModal